import { faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor as ClassicEditor } from "ckeditor5-custom-build/build/ckeditor";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { useForm, useFieldArray } from "react-hook-form";
import { useEffect, useReducer, useState } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { useNavigate, useParams } from "react-router-dom";

const AdminAddEditBlog = () => {
  const [values, setValues] = useState(null);
  const [content, setContent] = useState("");
  const { blogID } = useParams();
  const navigate = useNavigate();

  function reducer(state, action) {
    switch (action.type) {
      case "setSubmitAddEditBlog": {
        return {
          ...state,
          submitAddEditBlog: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddEditBlog: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  let api = blogID
    ? process.env.REACT_APP_ADMIN_BLOG_UPDATE_API
    : process.env.REACT_APP_ADMIN_BLOG_ADD_API;

  //!--------- add edit Video -------

  const [BlogAddEditSuccess, BlogAddEditErrors, submitLoading] = useAxios(
    api,
    "POST",
    state.submitAddEditBlog.flag,
    state.submitAddEditBlog.dependency,
    state.submitAddEditBlog.data,
    true
  );

  //!--------- get the Video info for editing -------

  const [BlogInfo, BlogInfoErrors] = useAxios(
    `${process.env.REACT_APP_ADMIN_BLOG_VIEW_API}${blogID}`,
    "GET",
    blogID,
    blogID
  );

  useEffect(() => {
    if (BlogInfo) {
      setValues(BlogInfo.data);
      setContent(BlogInfo.data.content);
    }
  }, [BlogInfo]);

  useEffect(() => {
    //!---add actions ----
    if (BlogAddEditSuccess) {
      navigate(-1);
    }
  }, [BlogAddEditSuccess]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    control,
  } = useForm({ mode: "onTouched", values });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "keywords",
    defaultValues: { keywords: [{ name: "" }] },
  });
  useEffect(() => {
    if (!fields.length) {
      append({ name: "" });
    }
  }, []);

  const onSubmit = (data) => {
    const finalData = blogID
      ? {
          name:data.name,
          title: data.title,
          keywords: data.keywords,
          id: blogID,
          visibility: +data.visibility,
          content: content,
        }
      : {
          ...data,
          visibility: 0,
          content: content,
        };

    dispatch({
      type: "setSubmitAddEditBlog",
      payload: {
        flag: "AddEditBlog",
        dependency: !state.submitAddEditBlog.dependency,
        data: finalData,
      },
    });
  };

  return (
    <section className="flex h-auto w-full flex-col  items-center  dark:bg-dark dark:text-light">
      <HelmetTags title="Blog | Nash Academy"></HelmetTags>
      <div className="form-container my-20 flex w-full flex-col items-center">
        <h2 className="my-20 text-center text-3xl font-semibold">
          {values ? "Edit " : "Please fill in the information to add the "} Blog
        </h2>

        <form
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className="md:max-w-3/4 flex  w-3/4  flex-col items-start justify-center gap-10 rounded-3xl bg-blue-200 p-16 shadow-lg shadow-blue-200/50"
        >
          <div className="flex w-full flex-col items-start justify-center  gap-5  md:w-full">
            {/* title  */}
            <div className="flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="title">Title</label>
              <input
                className="signin-inputs w-full pl-4    "
                type="text"
                id="title"
                placeholder="Title"
                name="title"
                autoComplete="on"
                {...register("title", {
                  required: true,
                  maxLength: 100,
                  minLength: 3,
                })}
              />
              {errors.title && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.title.type === "required" &&
                    "Please fill out this field"}
                </p>
              )}
              {
                //!-------server errors -----

                BlogAddEditErrors &&
                  BlogAddEditErrors?.response?.data?.errors?.title && (
                    <p className="w-full  text-[12px] text-blue-900  ">
                      {BlogAddEditErrors?.response?.data?.errors?.title[0]}
                    </p>
                  )
              }
            </div>

            {/* name  */}
            <div className="flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="name">Name</label>
              <input
                className="signin-inputs w-full pl-4    "
                type="text"
                id="name"
                placeholder="Name"
                name="name"
                autoComplete="on"
                {...register("name", {
                  required: true,
                  maxLength: 40,
                  minLength: 3,
                })}
              />
              {errors.name && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.name.type === "required" &&
                    "Please fill out this field"}
                </p>
              )}
              {
                //!-------server errors -----

                BlogAddEditErrors &&
                  BlogAddEditErrors?.response?.data?.errors?.name && (
                    <p className="w-full  text-[12px] text-blue-900  ">
                      {BlogAddEditErrors?.response?.data?.errors?.name[0]}
                    </p>
                  )
              }
            </div>

            {/* content  */}
            <div className="flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="content">Content</label>
              <CKEditor
                config={{
                  toolbar: {
                    items: [
                      "undo",
                      "redo",
                      "|",
                      "imageInsert",
                      "|",
                      "heading",
                      "bold",
                      "italic",
                      "strikethrough",
                      "underline",
                      "link",
                      "blockQuote",
                      "removeFormat",
                      "|",
                      "selectAll",
                      "specialCharacters",
                      "superscript",
                      "subscript",
                      "style",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "outdent",
                      "indent",
                      "|",
                      "mediaEmbed",
                      "insertTable",
                      "|",
                      "fontFamily",
                      "fontColor",
                      "fontBackgroundColor",
                      "fontSize",
                      "highlight",
                      "|",
                      "horizontalLine",
                      "pageBreak",
                      "findAndReplace",
                      "restrictedEditingException",
                      "textPartLanguage",
                      "-",
                    ],
                    shouldNotGroupWhenFull: true,
                  },
                  language: "en",
                  image: {
                    toolbar: [
                      "imageTextAlternative",
                      "toggleImageCaption",
                      "imageStyle:inline",
                      "imageStyle:block",
                      "imageStyle:side",
                    ],
                  },
                  table: {
                    contentToolbar: [
                      "tableColumn",
                      "tableRow",
                      "mergeTableCells",
                      "tableCellProperties",
                      "tableProperties",
                    ],
                  },
                }}
                editor={ClassicEditor}
                data={content}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setContent(data);
                }}
              />
              {errors.content && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.content.type === "required" &&
                    "Please fill out this field"}
                </p>
              )}
              {
                //!-------server errors -----

                BlogAddEditErrors &&
                  BlogAddEditErrors?.response?.data?.errors?.content && (
                    <p className="w-full  text-[12px] text-blue-900  ">
                      {BlogAddEditErrors?.response?.data?.errors?.content[0]}
                    </p>
                  )
              }
            </div>

            {/* keywords */}
            <div className="flex w-full flex-col items-start justify-center gap-2 md:w-full">
              <label>Keywords</label>
              {fields.map((item, index) => (
                <div key={item.id} className="flex items-center gap-2 w-full">
                  <input
                    className="signin-inputs w-full pl-4"
                    type="text"
                    placeholder="Keyword"
                    {...register(`keywords.${index}.name`, {
                      required: true,
                    })}
                  />
                  <button type="button" onClick={() => remove(index)}>
                    <FontAwesomeIcon icon={faTrash} className="text-red-600" />
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => append()}
                className="mt-2 submit !w-fit px-3 py-1"
              >
                Add Keyword
              </button>
            </div>

            {/* visibility  */}
            {blogID && (
              <div className="visibility flex w-full flex-col items-end justify-center gap-2 md:w-full">
                <div className="flex w-full items-center justify-end gap-10">
                  <label className="visibility-switch">
                    <input
                      className=""
                      id="visibility"
                      name="visibility"
                      {...register("visibility", {
                        required: false,
                      })}
                      type="checkbox"
                    />
                    <span className="visibility-slider">
                      <svg
                        className="slider-icon"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <path fill="none" d="m4 16.5 8 8 16-16"></path>
                      </svg>
                    </span>
                  </label>
                  <div>
                    <label
                      className="w-full cursor-pointer truncate"
                      htmlFor="visibility"
                    >
                      visibility
                    </label>
                  </div>
                </div>

                {errors.visibility && (
                  <p className="text-[12px] text-white ">
                    {errors.visibility.type === "required" &&
                      "برجاء ملئ هذا الحقل"}{" "}
                  </p>
                )}
                {
                  //!-------server errors -----

                  BlogAddEditErrors &&
                    BlogAddEditErrors?.response?.data?.errors?.visibility && (
                      <p className="w-full text-end text-[12px] text-white  ">
                        {
                          BlogAddEditErrors?.response?.data?.errors
                            ?.visibility[0]
                        }
                      </p>
                    )
                }
              </div>
            )}
          </div>

          {/** submit */}

          <button
            disabled={
              !isValid || (submitLoading && state.submitAddEditBlog.flag)
            }
            className=" submit mt-6 w-full "
            type="submit"
          >
            {submitLoading && state.submitAddEditBlog.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p>{values ? "Edit " : "Add "} Blog</p>
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default AdminAddEditBlog;
